import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';

@Component({
  selector: 'adminapp-error-handler-template',
  templateUrl: './error-handler-template.component.html',
  styleUrls: ['./error-handler-template.component.scss']
})
export class ErrorHandlerTemplateComponent implements OnInit {

  displayDescription: string;
  displayAction: string;
  displayContact: string;
  @Input() title: any;
  @Input()
  set description(description: string) {
    this.displayDescription = this.processString(description);
    const descrpDiv = document.getElementById('description');
    descrpDiv.innerHTML = this.displayDescription;
  }
  @Input() icon: string;
  @Input()
  set action(action: string) {
    this.displayAction = this.processString(action);
    const actionDiv = document.getElementById('action');
    actionDiv.innerHTML = this.displayAction;
  }
  @Input()
  set contact(contact: string) {
    this.displayContact = this.processString(contact);
    const actionDiv = document.getElementById('contact');
    actionDiv.innerHTML = this.displayContact;
  }
  constructor() { }

  ngOnInit() {
  }

  processString(description: string): string {
    return description.replace(/\n/g, '<br>');
  }

}
